var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',[_c('v-container',[_c('v-switch',{attrs:{"label":("ゲストの課題投稿を許可 " + _vm.message)},on:{"change":_vm.save},model:{value:(_vm.isUpload),callback:function ($$v) {_vm.isUpload=$$v},expression:"isUpload"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }